﻿﻿import { IContact } from './contact';
import { IUser } from './user';

export interface ICommunicationLogContact {
    id: number;
    communicationLogId: number;
    contactId: number;
    contact: IContact;
    createdBy: number;
    createdByUser: IUser;
    createdDate: string;
}
